import React from 'react';
import { Text } from '@cashfree-intl/coherent';

export const toggleStateText = (toggleState: boolean) =>
  toggleState ? (
    <Text color="success" variant="b12">
      Active
    </Text>
  ) : (
    <Text variant="b12" color="bodyLight">
      Activate
    </Text>
  );

export const isWalletDisabled = (walletBalance: number, active: boolean) =>
  walletBalance < 5000 && !active;
